import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
import { db } from "../../../firebase/firebaseConfig";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa6";

const HomeHighlightPrograms = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const navigate = useNavigate();

  const [programs, setPrograms] = useState([]);

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const q = query(
          collection(db, "programs"),
          orderBy("displayOrder"),
          limit(6)
        );
        const snapshot = await getDocs(q);
        const list = [];
        snapshot.forEach((doc) => {
          const data = doc.data();
          list.push({
            slug: data.slug,
            name: data.name || {},
            level: data.level || {},
            description: data.description || {}
          });
        });
        setPrograms(list);
      } catch (err) {
        console.error("Failed to fetch highlight programs:", err);
      }
    };
    fetchPrograms();
  }, []);

  return (
    <section className="py-14 bg-bg">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-extrabold text-center text-primary mb-10">
          <span className="mr-2 text-secondary text-2xl align-middle">🎯</span>
          {t("home.highlightPrograms")}
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {programs.map((program) => {
            const level = program.level?.[lang] || program.level?.vi || program.slug;
            const name = program.name?.[lang] || program.name?.vi || level;
            let description = program.description?.[lang] || program.description?.vi || "";

            // Cắt description tối đa 200 ký tự, thêm “…” nếu dài hơn
            const MAX_LEN = 200;
            if (description.length > MAX_LEN) {
              description = description.slice(0, MAX_LEN) + "…";
            }

            return (
              <Link
                key={program.slug}
                to={`/chuong-trinh/${program.slug}`}
                className="
                  group block bg-card rounded border border-border 
                  hover:shadow-md hover:border-primary 
                  transition p-7 min-h-[240px] flex flex-col
                "
              >
                <div className="flex items-center gap-2 mb-3">
                  <FaStar className="text-secondary text-xl" />
                  <span className="text-primary font-bold text-base">{level}</span>
                </div>
                <h3 className="text-xl font-extrabold text-menu group-hover:text-primary transition mb-2">{name}</h3>
                <p className="text-text2 text-sm flex-1">{description}</p>
              </Link>
            );
          })}
        </div>
        <div className="mt-10 flex justify-center">
          <button
            className="bg-primary hover:bg-secondary text-white font-bold px-8 py-2 rounded shadow-sm transition text-base"
            onClick={() => navigate("/chuong-trinh")}
          >
            {t("home.allPrograms")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomeHighlightPrograms;
